import axios from '@/utils/axios'
// 组件列表总数据
export function linklist(query) {
    return axios({
        url: '/novelPostlink/getLinkList',
        method: 'get',
        params: query
    })
}
// 详情组件列表
export function list(query) {
    return axios({
        url: '/novelPostlink/getStatList',
        method: 'get',
        params: query
    })
}
//代理商列表
export function agentlist() {
    return axios({
        url: '/video/user/agent/nameList',
        method: 'get',
    })
}